/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import ProgramContinuedSupportCard from './ProgramContinuedSupportCard';
import SingleImage from './SingleImage';

/* Services */
/* Styles */

/**
 *
 * @param {Object} sectionContent
 *  @param {String} lang
 *  @param {String} region
 * @returns {ReactElement} ProgramSupport
 */
const ProgramContinuedSupport = ({ sectionContent, region, lang, pageData }) => {
  return (
    <Box position={'relative'} pb={{ base: '60px', md: '80px', lg: '104px' }}>
      <SingleImage
        display={{ base: 'none', md: 'block' }}
        sectionContent={sectionContent[2]}
        region={region}
        position="absolute"
        bottom="0"
        left="0"
        my="0px"
        px="0px"
        lang={lang}
        w={{ base: '100%' }}
        h={{ base: '100%' }}
        maxW={{ base: '100%', md: '10%', xl: '13%', '2xl': '15%' }}
        lineHeight="0px"
      />
      <Box
        maxW={1030}
        w="100%"
        mx="auto"
        pos="relative"
        mt={sectionContent[2]?.image?.url ? '0px' : '45px'}
        pt={sectionContent[2]?.image?.url && '45px'}
      >
        <Flex
          as="section"
          w="full"
          flexDir="column"
          px={{ base: '16px', xl: '0px' }}
          pt={{ md: '35px' }}
        >
          <StructuredTextParser
            str={render(sectionContent[0]?.body)}
            fontFamily="FedraSansStd-medium"
            fontSize={{ base: '24px', md: '34px' }}
            lineHeight={{ base: '29px', xl: '44px' }}
            mb={{ base: '35px', lg: '40px' }}
            fontWeight={500}
            maxW="100%"
            textAlign={{ base: 'left', md: 'center' }}
            color={{ base: '#3B444B', md: '#000000' }}
            mt="0px"
          />
          <Flex
            flexWrap="wrap"
            justifyContent="center"
            gridColumnGap={{ base: '28px', md: '28px' }}
            gridRowGap={{ base: '28px', md: '34px' }}
            css={{
              '-webkit-grid-row-gap': '25px !important',
              '-webkit-grid-column-gap': '38px',
            }}
          >
            {sectionContent[1]?.cards?.map((card, index) => {
              return (
                <ProgramContinuedSupportCard
                  card={card}
                  lang={lang}
                  region={region}
                  key={nanoid()}
                  pageData={pageData}
                />
              );
            })}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default ProgramContinuedSupport;
